import React, { useState, useEffect, useContext } from 'react';
import FieldDropdown from '../../../../components/FieldDropdown/FieldDropdown';
import { API } from '../../../../API/API';
import { UserContext } from '../../../../context/UserContext';
import FieldDate from '../../../../components/FieldDate/FieldDate';
import FieldText from '../../../../components/FieldText/FieldText';
import { message } from 'antd';
import { MessageConst } from '../../../../const/MessageConst';
import { Row, Col } from 'antd';
import FieldNumberFormat from '../../../../components/FieldNumberFormat/FieldNumberFormat';
import { constData } from '../../../../const/Const';
import ButtonSecondary from '../../../../components/ButtonSecondary/ButtonSecondary';
import FieldTextArea from '../../../../components/FieldTextArea/FieldTextArea';
import FieldItemList from '../../../../components/FieldItemList/FieldItemList';
import PanelBase from '../../../../components/PanelBase/PanelBase';
import ButtonDefaultWithLoad from '../../../../components/ButtonDefaultWithLoad/ButtonDefaultWithLoad';

const EmpEmplHistNewHR = (props) => {

    const { userInfo } = useContext(UserContext);

    const [warning, setWarning] = useState();
    const [initialData] = useState({
        "employmenttype": "HR",
        "historyid": -1,
        "ordertype": null,
        "depid": null,
        "positionid": null,
        "begindate": null,
        "enddate": null,
        "basewagecurrcode": "MNT",
        "basewage": 0,
        "insuretypeid": null,
        "labourcondition": "N",
        "ismult": null,
        "multyear": 0,
        "note": null,
        "empid": props.empid,
        "companyid": userInfo.companyid ? userInfo.companyid.toString().toUpperCase() : "",
        "isgovcompany": false,
        "companyname": userInfo.companyname ? userInfo.companyname : "",
        "emptype": props.emptype
    });

    const [data, setData] = useState({ ...initialData });
    const [dataInval, setDataInval] = useState({ empid: props.empid });
    const [dLabourCondition] = useState(constData.hrContract_LabourCondition);

    const [checkRule, setCheckRule] = useState(false);
    const [colSpan] = useState(window.innerWidth > 800 ? 12 : 24);

    const [loading, setLoading] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);
    const [step, setStep] = useState(1);

    const [addStep, setAddStep] = useState(false);

    const [dReason] = useState(constData.hrempinvalid_reason);
    const [dDuration] = useState(constData.hrempinvalid_duration);
    const [dDecision] = useState(constData.hrempinvalid_decision);

    const getExistsData = async () => {
        let tData = { ...initialData };
        if (props.historyid > 0) {
            setLoading(true);
            await API.get('/api/humanresource/employment/get_empemplhist?historyid=' + props.historyid).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    if (response.data.retdata?.length > 0) {
                        tData = response.data.retdata[0];
                    }
                }
            });

            setLoading(false);
        }
        setStep(1);
        setData(tData);

    }

    useEffect(() => {
        getExistsData();
    }, [props.historyid])

    const fieldOnChanged = async (key, text, field, fieldname) => {
        if (field) {
            let tData = { ...data };
            tData[field] = key;
            if (fieldname) {
                tData[fieldname] = text;
            }

            if (field == 'depid') {
                tData.positionid = null;
            }

            if (field == 'insuretypeid') {
                if (key == 54) {
                    setAddStep(true);
                } else {
                    setAddStep(false);
                }
            }

            setData(tData);
        }
    }

    const fieldOnChangedInval = (key, text, field, fieldname) => {
        if (field) {
            let tData = { ...dataInval };
            tData[field] = key;
            if (fieldname) {
                tData[fieldname] = text;
            }
            setDataInval(tData);
        }

    }

    const onSave = async () => {
        setWarning();
        setCheckRule(true);

        let vRule = true;

        let tData = { ...data };

        if (addStep) {
            if (!dataInval.reason || !data.decision) {
                vRule = false;
            }
        }

        if (vRule) {
            try {
                setLoadingSave(true);
                if (addStep) {
                    let tDataInval = { ...dataInval };
                    tDataInval.empid = props.empid;
                    await API.post('/api/humanresource/employee/invalid', tDataInval).then(response => {
                    });
                }

                tData.empid = props.empid;
                tData.emptype = props.emptype;
                await API.post('/api/humanresource/employment/save_empemplhist', [tData]).then(response => {
                    if (response.status == 200 && response.data.rettype == 0) {
                        message.success(MessageConst.success);
                        props.afterSave();
                        onDismiss();
                    }
                });

            } finally {
                setLoadingSave(false);
            }

        } else {
            setWarning("Заавал бөглөх талбарын утга хоосон байна.");
        }
    }

    const onDismiss = () => {
        setData({ ...initialData });
        setWarning();
        setStep(1);
        setCheckRule(false);
        props.onDismiss();
    }

    const onDelete = () => {
        API.post('/api/humanresource/employment/delete_empemplhist?historyid=' + props.historyid).then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                message.success(MessageConst.success);
                props.afterSave();
                onDismiss();
            }
        });
    }

    let vPanel = null;

    if (step == 1) {
        vPanel = (
            <div>
                <Row gutter={[16, 16]} style={{ marginTop: 13 }}>
                    <Col span={colSpan}>
                        <FieldText loading={loading} disable={true} onChanged={fieldOnChanged} title="Хуулийн этгээд" keyfield='companyname' defaultValue={data.companyname} />
                    </Col>
                    <Col span={colSpan}>
                        <FieldItemList loading={loading} required onChanged={fieldOnChanged} title="Даатгуулагчийн төрөл" keyfield='insuretypeid' keyfieldname='insuretypename' defaultValue={[{ key: data.insuretypeid, name: data.insuretypename }]} checkreq={checkRule} dataurl="/api/humanresource/organization/get_insure_type_dropdown" />
                    </Col>
                </Row>
                <Row gutter={[16, 16]} style={{ marginTop: 13 }}>
                    <Col span={colSpan}>
                        <FieldItemList loading={loading} required onChanged={fieldOnChanged} title="Дотоод нэгж" keyfield='depid' keyfieldname='depname' defaultValue={[{ key: data.depid, name: data.depname }]} dataurl='/api/humanresource/organization/get_department_dropdown' dataparam={[{ key: 'companyid', name: userInfo.companyid }]} checkreq={checkRule} />
                    </Col>
                    <Col span={colSpan}>
                        <FieldItemList loading={loading} disable={data.depid ? false : true} required onChanged={fieldOnChanged} title="Ажлын байр" keyfield='positionid' keyfieldname='positionname' defaultValue={[{ key: data.positionid, name: data.positionname }]} dataurl="/api/humanresource/organization/get_position_dropdown" dataparam={[{ key: 'depid', name: data.depid }]} checkreq={checkRule} />
                    </Col>
                </Row>
                <Row gutter={[16, 16]} style={{ marginTop: 13 }}>
                    <Col span={colSpan}>
                        <FieldDate loading={loading} required onChanged={fieldOnChanged} title="Эхэлсэн огноо" keyfield='begindate' defaultValue={data.begindate} checkreq={checkRule} />
                    </Col>
                    <Col span={colSpan}>
                        <FieldDate loading={loading} onChanged={fieldOnChanged} title="Дууссан огноо" keyfield='enddate' defaultValue={data.enddate} checkreq={checkRule} />
                    </Col>
                </Row>
                <Row gutter={[16, 16]} style={{ marginTop: 13 }}>
                    <Col span={colSpan}>
                        <Row gutter={[16, 16]}>
                            <Col span={20}>
                                <FieldNumberFormat loading={loading} required onChanged={fieldOnChanged} title="Үндсэн цалин" keyfield='basewage' defaultValue={data.basewage} checkreq={checkRule} />
                            </Col>
                            <Col span={4}>
                                <FieldText loading={loading} disable={true} title="Валют" keyfield='basewagecurrcode' defaultValue={data.basewagecurrcode} />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={colSpan}>
                        <FieldDropdown loading={loading} required onChanged={fieldOnChanged} title="Хөдөлмөрийн нөхцөл" data={dLabourCondition} keyfield='labourcondition' defaultValue={data.labourcondition} checkreq={checkRule} />
                    </Col>
                </Row>
                <Row gutter={[16, 16]} style={{ marginTop: 13 }}>
                    <Col span={24}>
                        <FieldTextArea loading={loading} onChanged={fieldOnChanged} title="Нэмэлт мэдээлэл" keyfield='note' defaultValue={data.note} />
                    </Col>
                </Row>
            </div>
        );
    } else if (step == 2) {
        vPanel = (
            <div>
                <FieldDropdown required title="ХЧА шалтгаан" onChanged={fieldOnChangedInval} keyfield='reason' defaultValue={dataInval.reason} data={dReason} checkreq={checkRule} />
                <div style={{ marginTop: 13 }}>
                    <FieldItemList
                        title="Өвчний ангилал"
                        onChanged={fieldOnChangedInval}
                        keyfield='illnessid'
                        keyfieldname='illnessname'
                        defaultValue={[{ key: dataInval.illnessid, name: dataInval.illnessname }]}
                        dataurl="/api/humanresource/employee/invalid/get_illness_dropdown"
                    />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldDate title="Групп тогтоосон огноо" onChanged={fieldOnChangedInval} keyfield='invalidbegdate' defaultValue={dataInval.invalidbegdate} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldDropdown title="Үргэлжлэх хугацаа" onChanged={fieldOnChangedInval} keyfield='duration' defaultValue={dataInval.duration} data={dDuration} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldDropdown required title="Комиссын шийдвэр" onChanged={fieldOnChangedInval} keyfield='decision' defaultValue={dataInval.decision} data={dDecision} checkreq={checkRule} />
                </div>
            </div>
        );
    }

    const onNextStep = () => {

        let vRule = true;
        setCheckRule(true);
        setWarning();

        if (step == 1) {
            if (!data.depid ||
                !data.positionid ||
                !data.begindate ||
                !data.basewage ||
                !data.labourcondition ||
                !data.insuretypeid) {
                vRule = false;
            }
        }

        if (vRule) {
            setStep(r => r + 1);
            setCheckRule(false);
        } else {
            setWarning("Заавал бөглөх талбарын утга хоосон байна.");
        }
    }

    const onPrevStep = () => {
        setStep(r => r - 1);
    }


    let compSave = null;

    if (step == 1) {
        compSave = (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                {addStep ? (
                    <ButtonSecondary text="Үргэлжлүүлэх" onClick={onNextStep} />
                ) : (
                    <ButtonDefaultWithLoad disable={props.disable} loading={loadingSave} onClick={onSave} text="Хадгалах" />
                )}
            </div>
        );
    } else if (step == 2) {
        compSave = (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div>
                    <ButtonSecondary text="Буцах" onClick={onPrevStep} />
                </div>
                <div style={{ marginLeft: 16 }}>
                    <ButtonDefaultWithLoad loading={loadingSave} onClick={onSave} text="Хадгалах" />
                </div>
            </div>
        );
    }

    let vStepStatus = addStep ? ' (' + step + '/2)' : '';

    return (
        <PanelBase
            headerText={props.historyid > 0 ? 'Ажилд авсан түүх засах' + vStepStatus : 'Ажилд авсан түүх нэмэх' + vStepStatus}
            isOpen={props.onOpen}
            onDismiss={onDismiss}
            PanelType='large'
            delete={!props.disable}
            onDelete={onDelete}
            buttons={compSave}
        >
            <div style={{ marginTop: 25 }}>
                {vPanel}
            </div>
        </PanelBase >
    );
}

export default EmpEmplHistNewHR;